// extracted by mini-css-extract-plugin
export default {"mobileCategories":"MobileCategories_mobileCategories__RfoER","mobileCategoriesMenu":"MobileCategories_mobileCategoriesMenu__SAAlN"};